import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';


import IQBox from './IQBox.js';


import IQBox_random from './IQBox_random.js';



export default class IQRow extends React.Component {
  render() {

    //console.log("this.props.images", this.props.images)
    



    if(this.props.isAnswers == true)
    {
        console.log(this.props.handleClick)

        var boxes = [
          
            <IQBox isAnswer={this.props.isAnswers} handleClick={this.props.handleClick} value={1} p={3} images={this.props.images} initial_positions={this.props.initial_positions} instructions={this.props.instructions}></IQBox>,
            <IQBox_random handleClick={this.props.handleClick} value={0} images={this.props.images}></IQBox_random>,
            <IQBox_random handleClick={this.props.handleClick} value={0} images={this.props.images}></IQBox_random>,


        ].sort(() => Math.random() - 0.5)

      return (


        

        <div class="IQRow">

            {boxes}

        </div>


    );


  }


    else
    {

   
    return (


        

          <div class="IQRow">

              <IQBox p={0} images={this.props.images} initial_positions={this.props.initial_positions} instructions={this.props.instructions}></IQBox>
              <IQBox p={1} images={this.props.images} initial_positions={this.props.initial_positions} instructions={this.props.instructions}></IQBox>
              <IQBox visible={this.props.showLast} p={2} images={this.props.images} initial_positions={this.props.initial_positions} instructions={this.props.instructions}></IQBox>

          </div>


      );


    }
  }
}
